// // ---------- Debounce ----------
// function debounceCartPage(fn, wait) {
//   let t;
//   return (...a) => {
//     clearTimeout(t);
//     t = setTimeout(() => fn.apply(this, a), wait);
//   };
// }
// const debouncedRunCartDiscountUICartPage = debounceCartPage(runCartDiscountUICartPage, 150);

// // ---------- Variant Cache ----------
// const variantCacheCartPage = {};
// async function getComparePriceByVariantIdCartPage(id) {
//   if (variantCacheCartPage[id]) return variantCacheCartPage[id];
//   try {
//     const r = await fetch(`/variants/${id}.js`);
//     const v = await r.json();
//     return (variantCacheCartPage[id] = {
//       compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
//       price: v.price / 100
//     });
//   } catch {
//     return null;
//   }
// }

// // ---------- Helpers ----------
// const LIP_TYPES_CART_PAGE = ['lip balm','lip care','lip'];
// const EXCLUDED_TYPES_CART_PAGE = ['combo','flashsale','flashstore','merch','free'];

// // IP SALE EXCLUDE LISTS
// const EXCLUDED_VARIANT_IDS_CART_PAGE = [47393331740837, 42388327399589];
// const EXCLUDED_PRODUCT_IDS_CART_PAGE = [];

// function isIpSaleExcludedCartPage(item) {
//   return (
//     EXCLUDED_VARIANT_IDS_CART_PAGE.includes(item.variant_id) ||
//     EXCLUDED_PRODUCT_IDS_CART_PAGE.includes(item.product_id)
//   );
// }

// /* ================= NEW HELPER ================= */
// function hasAbove348EligibleCartPage(items) {
//   return items.some(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcludedCartPage(i)) return false;
//     if (EXCLUDED_TYPES_CART_PAGE.includes(t)) return false;
//     if (LIP_TYPES_CART_PAGE.includes(t)) return false;
    
//     const price = variantCacheCartPage[i.variant_id]?.price || 0;
//     return price > 348;
//   });
// }

// // ---------- Eligible (NON-LIP) ----------
// function getEligibleItemsCartPage(items) {
//   const allowCheap = hasAbove348EligibleCartPage(items);

//   //  NEW: total calculate (same filtering base)
//     const total = items.reduce((sum, i) => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcludedCartPage(i)) return false;
//     if (EXCLUDED_TYPES_CART_PAGE.includes(t)) return false;
//     if (LIP_TYPES_CART_PAGE.includes(t)) return false;

//     const price = variantCacheCartPage[i.variant_id]?.price || 0;

//     if (price <= 348 && !allowCheap) return sum;

//     return sum + price * i.quantity;
//     }, 0);

//     return items.filter(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcludedCartPage(i)) return false;
//     if (EXCLUDED_TYPES_CART_PAGE.includes(t)) return false;
//     if (LIP_TYPES_CART_PAGE.includes(t)) return false;

//     const price = variantCacheCartPage[i.variant_id]?.price || 0;

//     // 🔥 existing logic
//     if (price <= 348 && !allowCheap) return false;

//     // 🔥 NEW TOTAL CHECK (main condition)
//     if (total < 699) return false;

//     return true;
//   });
// }

// // ---------- Pricing Logic ----------
// function applyTieredPricingCartPage(cartItems) {

//   /* ================= LIP BUNDLE ================= */
//   const lipUnits = [];
//   cartItems.forEach(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcludedCartPage(i)) return;
//     if (!LIP_TYPES_CART_PAGE.includes(t)) return;

//     const unit =
//       variantCacheCartPage[i.variant_id]?.compare_price ||
//       i.original_line_price / i.quantity / 100;

//     for (let q = 0; q < i.quantity; q++) {
//       lipUnits.push({ key: i.key, price: unit });
//     }
//   });

//   lipUnits.sort((a,b) => b.price - a.price);

//   const lipPairs = Math.floor(lipUnits.length / 2);
//   const lipDiscountTotal = lipPairs * 35000;

//   const lipDiscountMap = {};
//   if (lipPairs) {
//     const used = lipUnits.slice(0, lipPairs * 2);
//     const original = used.reduce((s,u)=>s+u.price,0);

//     used.forEach(u => {
//       lipDiscountMap[u.key] = lipDiscountMap[u.key] || { qty:0, price:u.price };
//       lipDiscountMap[u.key].qty++;
//     });

//     Object.values(lipDiscountMap).forEach(v => {
//       v.discounted_total = Math.round(
//         lipDiscountTotal * ((v.qty * v.price) / original)
//       );
//     });
//   }

//   /* ================= TIER ITEMS ================= */
//   const tierUnits = [];
//   getEligibleItemsCartPage(cartItems).forEach(i => {
//     const unit =
//       variantCacheCartPage[i.variant_id]?.compare_price ||
//       i.original_line_price / i.quantity / 100;

//     for (let q = 0; q < i.quantity; q++) {
//       tierUnits.push({ key: i.key, price: unit });
//     }
//   });

//   const tierPricing = {
//     2:69900,3:99900,4:129500,5:169800,
//     6:199800,8:259000,9:299700
//   };

//   let discountedUnits = [], fullUnits = [], discountedTotal = 0;

//   if (tierUnits.length >= 9) {
//     discountedUnits = tierUnits.slice(0,9);
//     fullUnits = tierUnits.slice(9);
//     discountedTotal = tierPricing[9];
//   } else if (tierUnits.length === 7) {
//     discountedUnits = tierUnits.slice(0,6);
//     fullUnits = tierUnits.slice(6);
//     discountedTotal = tierPricing[6];
//   } else if (tierPricing[tierUnits.length]) {
//     discountedUnits = tierUnits;
//     discountedTotal = tierPricing[tierUnits.length];
//   } else {
//     fullUnits = tierUnits;
//   }

//   const discountedItems = [];
//   if (discountedUnits.length) {
//     const original = discountedUnits.reduce((s,u)=>s+u.price,0);
//     const map = {};
//     discountedUnits.forEach(u => {
//       map[u.key] = map[u.key] || { qty:0, price:u.price };
//       map[u.key].qty++;
//     });
//     Object.entries(map).forEach(([k,v]) => {
//       discountedItems.push({
//         key:k,
//         discounted_total: Math.round(
//           discountedTotal * ((v.qty * v.price) / original)
//         )
//       });
//     });
//   }

//   const nonDiscountedItems = [];

//   fullUnits.forEach(u => {
//     const f = nonDiscountedItems.find(x=>x.key===u.key);
//     f ? f.qty++ : nonDiscountedItems.push({ key:u.key, qty:1, price:u.price });
//   });

//   /* ================= MERGE LIP ================= */
//   Object.entries(lipDiscountMap).forEach(([k,v])=>{
//     discountedItems.push({ key:k, discounted_total:v.discounted_total });
//   });

//   const usedLipQty = lipPairs * 2;
//   const remainingLipUnits = lipUnits.slice(usedLipQty);
//   remainingLipUnits.forEach(u => {
//     const f = nonDiscountedItems.find(x => x.key === u.key);
//     f ? f.qty++ : nonDiscountedItems.push({ key:u.key, qty:1, price:u.price });
//   });

//   cartItems.forEach(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (EXCLUDED_TYPES_CART_PAGE.includes(t) || isIpSaleExcludedCartPage(i)) {
//       const unit =
//         variantCacheCartPage[i.variant_id]?.price ||
//         i.original_line_price / i.quantity / 100;

//       for (let q=0;q<i.quantity;q++){
//         const f = nonDiscountedItems.find(x=>x.key===i.key);
//         f ? f.qty++ : nonDiscountedItems.push({ key:i.key, qty:1, price:unit });
//       }
//     }
//   });

//   return { discountedItems, nonDiscountedItems };
// }

// // ---------- UI ----------
// function updateCartPricesDisplayCartPage(data) {
//   const map = {};
//   data.discountedItems.forEach(i=>{
//     map[i.key]=(map[i.key]||0)+i.discounted_total;
//   });
//   data.nonDiscountedItems.forEach(i=>{
//     map[i.key]=(map[i.key]||0)+(i.price*i.qty*100);
//   });

//   document.querySelectorAll('.custom-cart-page .cart-item__discounted-prices').forEach(c=>{

//     const key=c.dataset.key;
//     const qty=+c.dataset.quantity||1;
//     const v=variantCacheCartPage[c.dataset.variantId];
//     const old=c.querySelector('.cart-item__old-price');
//     const fin=c.querySelector('.cart-item__final-price');

//     if(!fin) return;

//     if (EXCLUDED_VARIANT_IDS_CART_PAGE.includes(parseInt(c.dataset.variantId))) {
//       fin.textContent = `₹${(v.price*qty).toFixed(2)}`;
//       if (old) old.style.display = 'none';
//       return;
//     }

//     const original = old?.dataset.originalPrice
//       ? parseFloat(old.dataset.originalPrice)
//       : parseFloat(fin.textContent.replace(/[^\d.]/g,'')) || 0;

//     const final = map[key]!==undefined ? map[key]/100 : original;

//     if (old && final < original) {
//       old.textContent=`₹${original.toFixed(2)}`;
//       old.style.display='inline-block';
//       old.style.textDecoration='line-through';
//     } else if (old) {
//       old.style.display='block';
//     }

//     fin.textContent =
//       final < original
//         ? `₹${final.toFixed(2)}`
//         : `₹${(v.price * qty).toFixed(2)}`;
//   });
// }


// function getTotalDiscountCartPage() {
//   let o = 0, f = 0;

//   document.querySelectorAll('.custom-cart-page .cart-item__discounted-prices').forEach(i => {

//     const oldEl = i.querySelector('.cart-item__old-price');
//     const finalEl = i.querySelector('.cart-item__final-price');


//     if (!finalEl) return;

//     let oldPrice = oldEl 
//       ? parseFloat(oldEl.textContent.replace(/[^\d.]/g, '')) 
//       : parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//     let finalPrice = parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//     if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
//       o += oldPrice;
//       f += finalPrice;
//     }

//   });

//   return o > f ? (o - f).toFixed(2) : '0.00';
// }

// // ---------- Main ----------
// async function runCartDiscountUICartPage(){
//   // console.log('run function runCartDiscountUICartPage');

//   const r=await fetch('/cart.js');
//   const cart=await r.json();
//   if(!cart.items.length) return;

//   await Promise.all(cart.items.map(i => getComparePriceByVariantIdCartPage(i.variant_id)));
//   if(cart.item_count===1) return;

//   const data=applyTieredPricingCartPage(cart.items);
//   updateCartPricesDisplayCartPage(data);

//   const saveCartPage=getTotalDiscountCartPage();
//   const tagCartPage=document.querySelector('.custom-cart-page #savings_cart_page');

//   // console.log('saveCartPage:'+saveCartPage);
//   // alert(saveCartPage);
//   if(tagCartPage && (saveCartPage > 0)){
//     tagCartPage.style.display='block';
//     tagCartPage.textContent='₹'+saveCartPage;
//   }
// }

// // ---------- Observers ----------
// document.addEventListener('DOMContentLoaded',debouncedRunCartDiscountUICartPage);
// document.addEventListener('shopify:section:load',debouncedRunCartDiscountUICartPage);
// new MutationObserver(debouncedRunCartDiscountUICartPage)
//   .observe(document.body,{childList:true,subtree:true});



// // ---------- Debounce ----------
// function debounce(fn, wait) {
//   let t;
//   return (...a) => {
//     clearTimeout(t);
//     t = setTimeout(() => fn.apply(this, a), wait);
//   };
// }
// const debouncedRunCartDiscountUI = debounce(runCartDiscountUI, 150);

// // ---------- Variant Cache ----------
// const variantCache = {};
// async function getComparePriceByVariantId(id) {
//   if (variantCache[id]) return variantCache[id];
//   try {
//     const r = await fetch(`/variants/${id}.js`);
//     const v = await r.json();
//     return (variantCache[id] = {
//       compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
//       price: v.price / 100
//     });
//   } catch {
//     return null;
//   }
// }

// // ---------- Helpers ----------
// const LIP_TYPES = ['lip balm','lip care','lip'];
// const EXCLUDED_TYPES = ['combo','flashsale','flashstore','merch','free'];

// // IP SALE EXCLUDE LISTS
// const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
// const EXCLUDED_PRODUCT_IDS = [];

// function isIpSaleExcluded(item) {
//   return (
//     EXCLUDED_VARIANT_IDS.includes(item.variant_id) ||
//     EXCLUDED_PRODUCT_IDS.includes(item.product_id)
//   );
// }

// /* ================= NEW HELPER ================= */

// function hasAbove348Eligible(items) {
//   return items.some(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcluded(i)) return false;
//     if (EXCLUDED_TYPES.includes(t)) return false;
//     if (LIP_TYPES.includes(t)) return false;

//     const price = variantCache[i.variant_id]?.price || 0;
//     return price > 348;
//   });
// }

// // ---------- Eligible (NON-LIP) ----------
// function getEligibleItems(items) {
//   const allowCheap = hasAbove348Eligible(items);

//   // 🔥 NEW: total calculate (same filtering base)
//   const total = items.reduce((sum, i) => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcluded(i)) return sum;
//     if (EXCLUDED_TYPES.includes(t)) return sum;
//     if (LIP_TYPES.includes(t)) return sum;

//     const price = variantCache[i.variant_id]?.price || 0;

//     if (price <= 348 && !allowCheap) return sum;

//     return sum + price * i.quantity;
//   }, 0);

//   return items.filter(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcluded(i)) return false;
//     if (EXCLUDED_TYPES.includes(t)) return false;
//     if (LIP_TYPES.includes(t)) return false;

//     const price = variantCache[i.variant_id]?.price || 0;

//     // 🔥 existing logic
//     if (price <= 348 && !allowCheap) return false;

//     // 🔥 NEW TOTAL CHECK (main condition)
//     if (total < 699) return false;

//     return true;
//   });
// }

// // ---------- Pricing Logic ----------
// function applyTieredPricing(cartItems) {

//   /* ================= LIP BUNDLE ================= */
//   const lipUnits = [];
//   cartItems.forEach(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (isIpSaleExcluded(i)) return;
//     if (!LIP_TYPES.includes(t)) return;

//     const unit =
//       variantCache[i.variant_id]?.price ||
//       i.original_line_price / i.quantity / 100;

//     for (let q = 0; q < i.quantity; q++) {
//       lipUnits.push({ key: i.key, price: unit });
//     }
//   });

//   lipUnits.sort((a,b) => b.price - a.price);

//   const lipPairs = Math.floor(lipUnits.length / 2);
//   const lipDiscountTotal = lipPairs * 35000;

//   const lipDiscountMap = {};
//   if (lipPairs) {
//     const used = lipUnits.slice(0, lipPairs * 2);
//     const original = used.reduce((s,u)=>s+u.price,0);

//     used.forEach(u => {
//       lipDiscountMap[u.key] = lipDiscountMap[u.key] || { qty:0, price:u.price };
//       lipDiscountMap[u.key].qty++;
//     });

//     Object.values(lipDiscountMap).forEach(v => {
//       v.discounted_total = Math.round(
//         lipDiscountTotal * ((v.qty * v.price) / original)
//       );
//     });
//   }


//   /* ================= TIER ITEMS ================= */
//   const tierUnits = [];
//   getEligibleItems(cartItems).forEach(i => {
//     const unit =
//       variantCache[i.variant_id]?.compare_price ||
//       i.original_line_price / i.quantity / 100;

//     for (let q = 0; q < i.quantity; q++) {
//       tierUnits.push({ key: i.key, price: unit });
//     }
//   });

//   const tierPricing = {
//     2:69900,3:99900,4:129500,5:169800,
//     6:199800,8:259000
//   };

//   let discountedUnits = [], fullUnits = [], discountedTotal = 0;

//   if (tierUnits.length >= 8) {
//     discountedUnits = tierUnits.slice(0,8);
//     fullUnits = tierUnits.slice(8);
//     discountedTotal = tierPricing[8];
//   } else if (tierUnits.length === 7) {
//     discountedUnits = tierUnits.slice(0,6);
//     fullUnits = tierUnits.slice(6);
//     discountedTotal = tierPricing[6];
//   } else if (tierPricing[tierUnits.length]) {
//     discountedUnits = tierUnits;
//     discountedTotal = tierPricing[tierUnits.length];
//   } else {
//     fullUnits = tierUnits;
//   }

//   const discountedItems = [];
//   if (discountedUnits.length) {
//     const original = discountedUnits.reduce((s,u)=>s+u.price,0);
//     const map = {};
//     discountedUnits.forEach(u => {
//       map[u.key] = map[u.key] || { qty:0, price:u.price };
//       map[u.key].qty++;
//     });
//     Object.entries(map).forEach(([k,v]) => {
//       discountedItems.push({
//         key:k,
//         discounted_total: Math.round(
//           discountedTotal * ((v.qty * v.price) / original)
//         )
//       });
//     });
//   }

//   const nonDiscountedItems = [];

//   fullUnits.forEach(u => {
//     const f = nonDiscountedItems.find(x=>x.key===u.key);
//     f ? f.qty++ : nonDiscountedItems.push({ key:u.key, qty:1, price:u.price });
//   });

//   /* ================= MERGE LIP ================= */
//   Object.entries(lipDiscountMap).forEach(([k,v])=>{
//     discountedItems.push({ key:k, discounted_total:v.discounted_total });
//   });

//   const usedLipQty = lipPairs * 2;
//   const remainingLipUnits = lipUnits.slice(usedLipQty);
//   remainingLipUnits.forEach(u => {
//     const f = nonDiscountedItems.find(x => x.key === u.key);
//     f ? f.qty++ : nonDiscountedItems.push({ key:u.key, qty:1, price:u.price });
//   });

//   cartItems.forEach(i => {
//     const t = i.product_type?.toLowerCase() || '';

//     if (EXCLUDED_TYPES.includes(t) || isIpSaleExcluded(i)) {
//       const unit =
//         variantCache[i.variant_id]?.price ||
//         i.original_line_price / i.quantity / 100;

//       for (let q=0;q<i.quantity;q++){
//         const f = nonDiscountedItems.find(x=>x.key===i.key);
//         f ? f.qty++ : nonDiscountedItems.push({ key:i.key, qty:1, price:unit });
//       }
//     }
//   });

//   return { discountedItems, nonDiscountedItems };
// }

// // ---------- UI ----------
// function updateCartPricesDisplay(data) {
//   const map = {};
//   data.discountedItems.forEach(i=>{
//     map[i.key]=(map[i.key]||0)+i.discounted_total;
//   });
//   data.nonDiscountedItems.forEach(i=>{
//     map[i.key]=(map[i.key]||0)+(i.price*i.qty*100);
//   });

//   document.querySelectorAll('.cart-drawer-unique-dr .cart-item__discounted-prices').forEach(c=>{

//     const key=c.dataset.key;
//     const qty=+c.dataset.quantity||1;
//     const v=variantCache[c.dataset.variantId];
//     const old=c.querySelector('.cart-item__old-price');
//     const fin=c.querySelector('.cart-item__final-price');

//     if(!fin) return;

//     if (EXCLUDED_VARIANT_IDS.includes(parseInt(c.dataset.variantId))) {
//       fin.textContent = `₹${(v.price*qty).toFixed(2)}`;
//       if (old) old.style.display = 'none';
//       return;
//     }

//     const original = old?.dataset.originalPrice
//       ? parseFloat(old.dataset.originalPrice)
//       : parseFloat(fin.textContent.replace(/[^\d.]/g,'')) || 0;

//     const final = map[key]!==undefined ? map[key]/100 : original;

//     if (old && final < original) {
//       old.textContent=`₹${original.toFixed(2)}`;
//       old.style.display='inline-block';
//       old.style.textDecoration='line-through';
//     } else if (old) {
//       old.style.display='block';
//     }

//     fin.textContent =
//       final < original
//         ? `₹${final.toFixed(2)}`
//         : `₹${(v.price * qty).toFixed(2)}`;
//   });
// }


// // ---------- Discount ----------
// function getTotalDiscount() {
//   let o = 0, f = 0;

//   document.querySelectorAll('.cart-drawer-unique-dr .cart-item__discounted-prices').forEach(i => {

//     const oldEl = i.querySelector('.cart-item__old-price');
//     const finalEl = i.querySelector('.cart-item__final-price');


//     if (!finalEl) return;

//     let oldPrice = oldEl 
//       ? parseFloat(oldEl.textContent.replace(/[^\d.]/g, '')) 
//       : parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//     let finalPrice = parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//     if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
//       o += oldPrice;
//       f += finalPrice;
//     }

//   });

//   return o > f ? (o - f).toFixed(2) : '0.00';
// }


// // ---------- Main ----------
// async function runCartDiscountUI(){
//   const r=await fetch('/cart.js');
//   const cart=await r.json();
//   if(!cart.items.length) return;

//   await Promise.all(cart.items.map(i => getComparePriceByVariantId(i.variant_id)));
//   if(cart.item_count===1) return;

//   const data=applyTieredPricing(cart.items);
//   updateCartPricesDisplay(data);

//   const save=getTotalDiscount();
//   const tag=document.querySelector('.cart-drawer-unique-dr .promo-code-tag');
//   if(tag && save>0){
//     tag.style.display='block';
//     tag.textContent='You Save ₹'+save;
//   }
// }

// // ---------- Observers ----------
// document.addEventListener('DOMContentLoaded',debouncedRunCartDiscountUI);
// document.addEventListener('shopify:section:load',debouncedRunCartDiscountUI);
// new MutationObserver(debouncedRunCartDiscountUI)
//   .observe(document.body,{childList:true,subtree:true});


//   // ---------- Public API (reuse in customers-also-bought, etc.) ----------
// /** Given result of applyTieredPricing(), returns total in paise. */
// function getTotalFromPricingResult(data) {
//   let total = 0;
//   (data.discountedItems || []).forEach((i) => {
//     total += i.discounted_total || 0;
//   });
//   (data.nonDiscountedItems || []).forEach((i) => {
//     total += (i.price || 0) * (i.qty || 0) * 100;
//   });
//   return total;
// }

// window.DotKeyIpSale = {
//   getComparePriceByVariantId,
//   applyTieredPricing,
//   getEligibleItems,
//   hasAbove348Eligible,
//   isIpSaleExcluded,
//   getTotalFromPricingResult,
//   LIP_TYPES,
//   EXCLUDED_TYPES,
//   EXCLUDED_VARIANT_IDS,
//   EXCLUDED_PRODUCT_IDS,
// };


// (function () {
//   if (window.__DOTKEY_CART_FINAL__) return;
//   window.__DOTKEY_CART_FINAL__ = true;

//   //////////////////////////////////////////////////////////////
//   // RAF Debounce
//   //////////////////////////////////////////////////////////////
//   function debounce(fn) {
//     let raf;
//     return (...args) => {
//       cancelAnimationFrame(raf);
//       raf = requestAnimationFrame(() => fn.apply(this, args));
//     };
//   }

//   //////////////////////////////////////////////////////////////
//   // Variant Cache
//   //////////////////////////////////////////////////////////////
//   const variantCache = {};

//   async function getComparePriceByVariantId(id) {
//     if (variantCache[id]) return variantCache[id];

//     try {
//       const r = await fetch(`/variants/${id}.js`, {
//         credentials: 'same-origin'
//       });

//       const v = await r.json();

//       return (variantCache[id] = {
//         compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
//         price: v.price / 100
//       });
//     } catch {
//       return null;
//     }
//   }

//   //////////////////////////////////////////////////////////////
//   // Constants
//   //////////////////////////////////////////////////////////////
//   const LIP_TYPES = ['lip balm', 'lip care', 'lip'];
//   const EXCLUDED_TYPES = ['combo', 'flashsale', 'flashstore', 'merch', 'free'];

//   const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
//   const EXCLUDED_PRODUCT_IDS = [];

//   //////////////////////////////////////////////////////////////
//   // Helpers
//   //////////////////////////////////////////////////////////////
//   function isIpSaleExcluded(item) {
//     return (
//       EXCLUDED_VARIANT_IDS.includes(item.variant_id) ||
//       EXCLUDED_PRODUCT_IDS.includes(item.product_id)
//     );
//   }

//   function hasAbove348Eligible(items) {
//     for (const i of items) {
//       const t = i.product_type?.toLowerCase() || '';

//       if (isIpSaleExcluded(i)) continue;
//       if (EXCLUDED_TYPES.includes(t)) continue;
//       if (LIP_TYPES.includes(t)) continue;

//       const price = variantCache[i.variant_id]?.price || 0;

//       if (price > 348) return true;
//     }

//     return false;
//   }

//   function getEligibleItems(items) {
//     const allowCheap = hasAbove348Eligible(items);
//     let total = 0;
//     const eligible = [];

//     for (const i of items) {
//       const t = i.product_type?.toLowerCase() || '';

//       if (isIpSaleExcluded(i)) continue;
//       if (EXCLUDED_TYPES.includes(t)) continue;
//       if (LIP_TYPES.includes(t)) continue;

//       const price = variantCache[i.variant_id]?.price || 0;

//       if (price <= 348 && !allowCheap) continue;

//       total += price * i.quantity;
//       eligible.push(i);
//     }

//     if (total < 699) return [];

//     return eligible;
//   }

//   //////////////////////////////////////////////////////////////
//   // Pricing Logic
//   //////////////////////////////////////////////////////////////
//   function applyTieredPricing(cartItems) {
//     const lipUnits = [];
//     const nonDiscountMap = {};
//     const lipDiscountMap = {};

//     for (const i of cartItems) {
//       const t = i.product_type?.toLowerCase() || '';

//       const unit =
//         variantCache[i.variant_id]?.price ||
//         i.original_line_price / i.quantity / 100;

//       if (LIP_TYPES.includes(t) && !isIpSaleExcluded(i)) {
//         for (let q = 0; q < i.quantity; q++) {
//           lipUnits.push({ key: i.key, price: unit });
//         }

//         continue;
//       }

//       if (EXCLUDED_TYPES.includes(t) || isIpSaleExcluded(i)) {
//         if (!nonDiscountMap[i.key]) {
//           nonDiscountMap[i.key] = {
//             key: i.key,
//             qty: 0,
//             price: unit
//           };
//         }

//         nonDiscountMap[i.key].qty += i.quantity;
//       }
//     }

//     lipUnits.sort((a, b) => b.price - a.price);

//     const lipPairs = Math.floor(lipUnits.length / 2);
//     const lipDiscountTotal = lipPairs * 35000;

//     if (lipPairs) {
//       const used = lipUnits.slice(0, lipPairs * 2);
//       let original = 0;

//       used.forEach(u => {
//         original += u.price;

//         if (!lipDiscountMap[u.key]) {
//           lipDiscountMap[u.key] = {
//             qty: 0,
//             price: u.price
//           };
//         }

//         lipDiscountMap[u.key].qty++;
//       });

//       Object.values(lipDiscountMap).forEach(v => {
//         v.discounted_total = Math.round(
//           lipDiscountTotal * ((v.qty * v.price) / original)
//         );
//       });
//     }

//     const tierUnits = [];
//     const eligibleItems = getEligibleItems(cartItems);

//     for (const i of eligibleItems) {
//       const unit =
//         variantCache[i.variant_id]?.compare_price ||
//         i.original_line_price / i.quantity / 100;

//       for (let q = 0; q < i.quantity; q++) {
//         tierUnits.push({
//           key: i.key,
//           price: unit
//         });
//       }
//     }

//     const tierPricing = {
//       2: 69900,
//       3: 99900,
//       4: 129500,
//       5: 169800,
//       6: 199800,
//       8: 259000
//     };

//     let discountedUnits = [];
//     let fullUnits = [];
//     let discountedTotal = 0;

//     if (tierUnits.length >= 8) {
//       discountedUnits = tierUnits.slice(0, 8);
//       fullUnits = tierUnits.slice(8);
//       discountedTotal = tierPricing[8];
//     } else if (tierUnits.length === 7) {
//       discountedUnits = tierUnits.slice(0, 6);
//       fullUnits = tierUnits.slice(6);
//       discountedTotal = tierPricing[6];
//     } else if (tierPricing[tierUnits.length]) {
//       discountedUnits = tierUnits;
//       discountedTotal = tierPricing[tierUnits.length];
//     } else {
//       fullUnits = tierUnits;
//     }

//     const discountedItems = [];
//     const discountMap = {};

//     if (discountedUnits.length) {
//       let original = 0;

//       discountedUnits.forEach(u => {
//         original += u.price;

//         if (!discountMap[u.key]) {
//           discountMap[u.key] = {
//             qty: 0,
//             price: u.price
//           };
//         }

//         discountMap[u.key].qty++;
//       });

//       Object.entries(discountMap).forEach(([k, v]) => {
//         discountedItems.push({
//           key: k,
//           discounted_total: Math.round(
//             discountedTotal * ((v.qty * v.price) / original)
//           )
//         });
//       });
//     }

//     fullUnits.forEach(u => {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = {
//           key: u.key,
//           qty: 0,
//           price: u.price
//         };
//       }

//       nonDiscountMap[u.key].qty++;
//     });

//     Object.entries(lipDiscountMap).forEach(([k, v]) => {
//       discountedItems.push({
//         key: k,
//         discounted_total: v.discounted_total
//       });
//     });

//     lipUnits.slice(lipPairs * 2).forEach(u => {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = {
//           key: u.key,
//           qty: 0,
//           price: u.price
//         };
//       }

//       nonDiscountMap[u.key].qty++;
//     });

//     return {
//       discountedItems,
//       nonDiscountedItems: Object.values(nonDiscountMap)
//     };
//   }

//   //////////////////////////////////////////////////////////////
//   // UI
//   //////////////////////////////////////////////////////////////
//   function updateCartPricesDisplay(data) {
//     const map = {};

//     data.discountedItems.forEach(i => {
//       map[i.key] = (map[i.key] || 0) + i.discounted_total;
//     });

//     data.nonDiscountedItems.forEach(i => {
//       map[i.key] = (map[i.key] || 0) + i.price * i.qty * 100;
//     });

//     const rows = document.querySelectorAll(
//       '.custom-cart-page .cart-item__discounted-prices'
//     );

//     rows.forEach(c => {
//       const key = c.dataset.key;
//       const qty = +c.dataset.quantity || 1;
//       const variantId = +c.dataset.variantId;
//       const v = variantCache[variantId];

//       const old = c.querySelector('.cart-item__old-price');
//       const fin = c.querySelector('.cart-item__final-price');

//       if (!fin || !v) return;

//       if (EXCLUDED_VARIANT_IDS.includes(variantId)) {
//         fin.textContent = `₹${(v.price * qty).toFixed(2)}`;

//         if (old) old.style.display = 'none';

//         return;
//       }

//       const original =
//         old?.dataset.originalPrice
//           ? parseFloat(old.dataset.originalPrice)
//           : parseFloat(fin.textContent.replace(/[^\d.]/g, '')) || 0;

//       const final = map[key] !== undefined ? map[key] / 100 : original;

//       if (old) {
//         if (final < original) {
//           old.textContent = `₹${original.toFixed(2)}`;
//           old.style.display = 'inline-block';
//           old.style.textDecoration = 'line-through';
//         } else {
//           old.style.display = 'none';
//         }
//       }

//       fin.textContent =
//         final < original
//           ? `₹${final.toFixed(2)}`
//           : `₹${(v.price * qty).toFixed(2)}`;
//     });
//   }

//   function getTotalDiscount() {
//     let o = 0;
//     let f = 0;

//     document.querySelectorAll(
//       '.custom-cart-page .cart-item__discounted-prices'
//     ).forEach(i => {
//       const oldEl = i.querySelector('.cart-item__old-price');
//       const finalEl = i.querySelector('.cart-item__final-price');

//       if (!finalEl) return;

//       const oldPrice = oldEl
//         ? parseFloat(oldEl.textContent.replace(/[^\d.]/g, ''))
//         : parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//       const finalPrice = parseFloat(finalEl.textContent.replace(/[^\d.]/g, ''));

//       if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
//         o += oldPrice;
//         f += finalPrice;
//       }
//     });

//     return o > f ? (o - f).toFixed(2) : '0.00';
//   }

//   //////////////////////////////////////////////////////////////
//   // Main
//   //////////////////////////////////////////////////////////////
//   async function runCartDiscountUI() {
//     try {
//       const r = await fetch('/cart.js', {
//         credentials: 'same-origin',
//         cache: 'no-store'
//       });

//       const cart = await r.json();

//       if (!cart.items.length) return;

//       await Promise.all(
//         cart.items.map(i => getComparePriceByVariantId(i.variant_id))
//       );

//       const data = applyTieredPricing(cart.items);

//       updateCartPricesDisplay(data);

//       const save = getTotalDiscount();

//       const tag = document.querySelector(
//         '.custom-cart-page #savings_cart_page'
//       );

//       if (tag) {
//         tag.style.display = save > 0 ? 'block' : 'none';
//         tag.textContent = save > 0 ? 'You Save ₹' + save : '';
//       }
//     } catch (e) {
//       console.error('[Cart Discount Error]', e);
//     }
//   }

//   const debouncedRunCartDiscountUI = debounce(runCartDiscountUI);

//   //////////////////////////////////////////////////////////////
//   // REFRESH
//   //////////////////////////////////////////////////////////////
//   let isRefreshing = false;
//   let queued = false;

//   function refreshCustomCartPage() {
//     if (isRefreshing) {
//       queued = true;
//       return;
//     }

//     isRefreshing = true;

//     fetch('/?sections=header,main-cart-footer', {
//       credentials: 'same-origin',
//       cache: 'no-store'
//     })
//       .then(r => r.json())
//       .then(data => {
//         const parser = new DOMParser();

//         const cartDoc = parser.parseFromString(
//           data['main-cart-footer'] || '',
//           'text/html'
//         );

//         const headerDoc = parser.parseFromString(
//           data.header || '',
//           'text/html'
//         );

//         const newCart = cartDoc.querySelector('.custom-cart-page');
//         const currentCart = document.querySelector('.custom-cart-page');

//         if (newCart && currentCart) {
//           currentCart.innerHTML = newCart.innerHTML;
//         }

//         const newBubbles = headerDoc.querySelectorAll('#cart-icon-bubble');
//         const currentBubbles = document.querySelectorAll('#cart-icon-bubble');

//         currentBubbles.forEach((bubble, i) => {
//           const source = newBubbles[i] || newBubbles[0];

//           if (!bubble || !source) return;

//           bubble.innerHTML = source.innerHTML;
//           bubble.className = source.className;
//         });

//         requestAnimationFrame(() => {
//           debouncedRunCartDiscountUI();
//         });
//       })
//       .catch(e => {
//         console.error('[Refresh Error]', e);
//       })
//       .finally(() => {
//         isRefreshing = false;

//         if (queued) {
//           queued = false;
//           refreshCustomCartPage();
//         }
//       });
//   }

//   //////////////////////////////////////////////////////////////
//   // FETCH + XHR HOOK
//   //////////////////////////////////////////////////////////////
//   const originalFetch = window.fetch;

//   window.fetch = function () {
//     const url = arguments[0];

//     return originalFetch.apply(this, arguments).then(response => {
//       try {
//         const requestURL =
//           typeof url === 'string' ? url : url?.url || '';

//         if (
//           /\/cart\/(add|change|update|clear)/.test(requestURL)
//         ) {
//           requestAnimationFrame(refreshCustomCartPage);
//         }
//       } catch (e) {}

//       return response;
//     });
//   };

//   const oldOpen = XMLHttpRequest.prototype.open;
//   const oldSend = XMLHttpRequest.prototype.send;

//   XMLHttpRequest.prototype.open = function (method, url) {
//     this._url = url;
//     return oldOpen.apply(this, arguments);
//   };

//   XMLHttpRequest.prototype.send = function () {
//     this.addEventListener('load', () => {
//       try {
//         if (
//           /\/cart\/(add|change|update|clear)/.test(this._url || '')
//         ) {
//           requestAnimationFrame(refreshCustomCartPage);
//         }
//       } catch (e) {}
//     });

//     return oldSend.apply(this, arguments);
//   };

//   //////////////////////////////////////////////////////////////
//   // OBSERVER
//   //////////////////////////////////////////////////////////////
//   const cartObserver = new MutationObserver(() => {
//     debouncedRunCartDiscountUI();
//   });

//   cartObserver.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   //////////////////////////////////////////////////////////////
//   // Events
//   //////////////////////////////////////////////////////////////
//   document.addEventListener(
//     'DOMContentLoaded',
//     debouncedRunCartDiscountUI
//   );

//   document.addEventListener(
//     'shopify:section:load',
//     debouncedRunCartDiscountUI
//   );

//   //////////////////////////////////////////////////////////////
//   // API
//   //////////////////////////////////////////////////////////////
//   window.DotKeyIpSale = {
//     getComparePriceByVariantId,
//     applyTieredPricing,
//     getEligibleItems,
//     hasAbove348Eligible,
//     isIpSaleExcluded,
//     LIP_TYPES,
//     EXCLUDED_TYPES,
//     EXCLUDED_VARIANT_IDS,
//     EXCLUDED_PRODUCT_IDS
//   };
// })();

// (function () {
//   if (window.__DOTKEY_CART_FINAL__) return;
//   window.__DOTKEY_CART_FINAL__ = true;

//   //////////////////////////////////////////////////////////////
//   // RAF Debounce
//   //////////////////////////////////////////////////////////////
//   function debounce(fn) {
//     let raf;
//     return function () {
//       cancelAnimationFrame(raf);
//       raf = requestAnimationFrame(fn);
//     };
//   }

//   //////////////////////////////////////////////////////////////
//   // Variant Cache
//   //////////////////////////////////////////////////////////////
//   const variantCache = Object.create(null);
//   let cartLock = false;
//   let refreshLock = false;
//   let queuedRefresh = false;
//   let lastCartSignature = '';

//   async function getComparePriceByVariantId(id) {
//     if (variantCache[id]) return variantCache[id];

//     try {
//       const r = await fetch('/variants/' + id + '.js', {
//         credentials: 'same-origin',
//         cache: 'force-cache'
//       });

//       if (!r.ok) return null;

//       const v = await r.json();

//       return (variantCache[id] = {
//         compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
//         price: v.price / 100
//       });
//     } catch {
//       return null;
//     }
//   }

//   //////////////////////////////////////////////////////////////
//   // Constants
//   //////////////////////////////////////////////////////////////
//   const LIP_TYPES = ['lip balm', 'lip care', 'lip'];
//   const EXCLUDED_TYPES = ['combo', 'flashsale', 'flashstore', 'merch', 'free'];

//   const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
//   const EXCLUDED_PRODUCT_IDS = [];

//   //////////////////////////////////////////////////////////////
//   // Helpers
//   //////////////////////////////////////////////////////////////
//   function isIpSaleExcluded(item) {
//     return (
//       EXCLUDED_VARIANT_IDS.includes(item.variant_id) ||
//       EXCLUDED_PRODUCT_IDS.includes(item.product_id)
//     );
//   }

//   function hasAbove348Eligible(items) {
//     for (const i of items) {
//       const t = (i.product_type || '').toLowerCase();

//       if (
//         isIpSaleExcluded(i) ||
//         EXCLUDED_TYPES.includes(t) ||
//         LIP_TYPES.includes(t)
//       ) continue;

//       const price = variantCache[i.variant_id]?.price || 0;

//       if (price > 348) return true;
//     }

//     return false;
//   }

//   function getEligibleItems(items) {
//     const allowCheap = hasAbove348Eligible(items);
//     let total = 0;
//     const eligible = [];

//     for (const i of items) {
//       const t = (i.product_type || '').toLowerCase();

//       if (
//         isIpSaleExcluded(i) ||
//         EXCLUDED_TYPES.includes(t) ||
//         LIP_TYPES.includes(t)
//       ) continue;

//       const price = variantCache[i.variant_id]?.price || 0;

//       if (price <= 348 && !allowCheap) continue;

//       total += price * i.quantity;
//       eligible.push(i);
//     }

//     return total < 699 ? [] : eligible;
//   }

//   //////////////////////////////////////////////////////////////
//   // Pricing Logic (UNCHANGED)
//   //////////////////////////////////////////////////////////////
//   function applyTieredPricing(cartItems) {
//     const lipUnits = [];
//     const nonDiscountMap = {};
//     const lipDiscountMap = {};

//     for (const i of cartItems) {
//       const t = (i.product_type || '').toLowerCase();

//       const unit =
//         variantCache[i.variant_id]?.price ||
//         i.original_line_price / i.quantity / 100;

//       if (LIP_TYPES.includes(t) && !isIpSaleExcluded(i)) {
//         for (let q = 0; q < i.quantity; q++) {
//           lipUnits.push({ key: i.key, price: unit });
//         }
//         continue;
//       }

//       if (EXCLUDED_TYPES.includes(t) || isIpSaleExcluded(i)) {
//         if (!nonDiscountMap[i.key]) {
//           nonDiscountMap[i.key] = { key: i.key, qty: 0, price: unit };
//         }
//         nonDiscountMap[i.key].qty += i.quantity;
//       }
//     }

//     lipUnits.sort((a, b) => b.price - a.price);

//     const lipPairs = Math.floor(lipUnits.length / 2);
//     const lipDiscountTotal = lipPairs * 35000;

//     if (lipPairs) {
//       const used = lipUnits.slice(0, lipPairs * 2);
//       let original = 0;

//       used.forEach(u => {
//         original += u.price;

//         if (!lipDiscountMap[u.key]) {
//           lipDiscountMap[u.key] = { qty: 0, price: u.price };
//         }

//         lipDiscountMap[u.key].qty++;
//       });

//       Object.values(lipDiscountMap).forEach(v => {
//         v.discounted_total = Math.round(
//           lipDiscountTotal * ((v.qty * v.price) / original)
//         );
//       });
//     }

//     const tierUnits = [];
//     const eligibleItems = getEligibleItems(cartItems);

//     for (const i of eligibleItems) {
//       const unit =
//         variantCache[i.variant_id]?.compare_price ||
//         i.original_line_price / i.quantity / 100;

//       for (let q = 0; q < i.quantity; q++) {
//         tierUnits.push({ key: i.key, price: unit });
//       }
//     }

//     const tierPricing = {
//       2: 69900,
//       3: 99900,
//       4: 129500,
//       5: 169800,
//       6: 199800,
//       8: 259000
//     };

//     let discountedUnits = [];
//     let fullUnits = [];
//     let discountedTotal = 0;

//     if (tierUnits.length >= 8) {
//       discountedUnits = tierUnits.slice(0, 8);
//       fullUnits = tierUnits.slice(8);
//       discountedTotal = tierPricing[8];
//     } else if (tierUnits.length === 7) {
//       discountedUnits = tierUnits.slice(0, 6);
//       fullUnits = tierUnits.slice(6);
//       discountedTotal = tierPricing[6];
//     } else if (tierPricing[tierUnits.length]) {
//       discountedUnits = tierUnits;
//       discountedTotal = tierPricing[tierUnits.length];
//     } else {
//       fullUnits = tierUnits;
//     }

//     const discountedItems = [];
//     const discountMap = {};

//     if (discountedUnits.length) {
//       let original = 0;

//       discountedUnits.forEach(u => {
//         original += u.price;

//         if (!discountMap[u.key]) {
//           discountMap[u.key] = { qty: 0, price: u.price };
//         }

//         discountMap[u.key].qty++;
//       });

//       Object.entries(discountMap).forEach(([k, v]) => {
//         discountedItems.push({
//           key: k,
//           discounted_total: Math.round(
//             discountedTotal * ((v.qty * v.price) / original)
//           )
//         });
//       });
//     }

//     fullUnits.forEach(u => {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = { key: u.key, qty: 0, price: u.price };
//       }
//       nonDiscountMap[u.key].qty++;
//     });

//     Object.entries(lipDiscountMap).forEach(([k, v]) => {
//       discountedItems.push({
//         key: k,
//         discounted_total: v.discounted_total
//       });
//     });

//     lipUnits.slice(lipPairs * 2).forEach(u => {
//       if (!nonDiscountMap[u.key]) {
//         nonDiscountMap[u.key] = { key: u.key, qty: 0, price: u.price };
//       }
//       nonDiscountMap[u.key].qty++;
//     });

//     return {
//       discountedItems,
//       nonDiscountedItems: Object.values(nonDiscountMap)
//     };
//   }

//   //////////////////////////////////////////////////////////////
//   // UI
//   //////////////////////////////////////////////////////////////
//   function updateCartPricesDisplay(data) {
//     const map = {};

//     data.discountedItems.forEach(i => {
//       map[i.key] = (map[i.key] || 0) + i.discounted_total;
//     });

//     data.nonDiscountedItems.forEach(i => {
//       map[i.key] = (map[i.key] || 0) + i.price * i.qty * 100;
//     });

//     document.querySelectorAll('.custom-cart-page .cart-item__discounted-prices')
//       .forEach(c => {
//         const key = c.dataset.key;
//         const qty = +c.dataset.quantity || 1;
//         const variantId = +c.dataset.variantId;
//         const v = variantCache[variantId];

//         if (!v) return;

//         const old = c.querySelector('.cart-item__old-price');
//         const fin = c.querySelector('.cart-item__final-price');

//         if (!fin) return;

//         const original =
//           old?.dataset.originalPrice
//             ? parseFloat(old.dataset.originalPrice)
//             : parseFloat(fin.textContent.replace(/[^\d.]/g, '')) || 0;

//         const final = map[key] !== undefined ? map[key] / 100 : original;

//         if (old) {
//           if (final < original) {
//             old.textContent = `₹${original.toFixed(2)}`;
//             old.style.display = 'inline-block';
//             old.style.textDecoration = 'line-through';
//           } else {
//             old.style.display = 'none';
//           }
//         }

//         fin.textContent =
//           final < original
//             ? `₹${final.toFixed(2)}`
//             : `₹${(v.price * qty).toFixed(2)}`;
//       });
//   }

//   function getTotalDiscount() {
//     let o = 0;
//     let f = 0;

//     document.querySelectorAll('.custom-cart-page .cart-item__discounted-prices')
//       .forEach(i => {
//         const oldEl = i.querySelector('.cart-item__old-price');
//         const finalEl = i.querySelector('.cart-item__final-price');

//         if (!finalEl) return;

//         const oldPrice = parseFloat(
//           (oldEl || finalEl).textContent.replace(/[^\d.]/g, '')
//         );

//         const finalPrice = parseFloat(
//           finalEl.textContent.replace(/[^\d.]/g, '')
//         );

//         if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
//           o += oldPrice;
//           f += finalPrice;
//         }
//       });

//     return o > f ? (o - f).toFixed(2) : '0.00';
//   }

//   //////////////////////////////////////////////////////////////
//   // Main
//   //////////////////////////////////////////////////////////////
//   async function runCartDiscountUI() {
//     if (cartLock) return;
//     cartLock = true;

//     try {
//       const r = await fetch('/cart.js', {
//         credentials: 'same-origin',
//         cache: 'no-store'
//       });

//       if (!r.ok) return;

//       const cart = await r.json();

//       const signature = cart.items
//         .map(i => `${i.key}:${i.quantity}`)
//         .join('|');

//       if (signature === lastCartSignature) return;
//       lastCartSignature = signature;

//       if (!cart.items.length) return;

//       await Promise.all(
//         cart.items.map(i => getComparePriceByVariantId(i.variant_id))
//       );

//       const data = applyTieredPricing(cart.items);

//       updateCartPricesDisplay(data);

//       const save = getTotalDiscount();

//       const tag = document.querySelector('.custom-cart-page #savings_cart_page');

//       if (tag) {
//         tag.style.display = save > 0 ? 'block' : 'none';
//         tag.textContent = save > 0 ? '- ₹' + save : '';
//       }
//     } catch (e) {
//     } finally {
//       cartLock = false;
//     }
//   }

//   const debouncedRun = debounce(runCartDiscountUI);

//   //////////////////////////////////////////////////////////////
//   // Refresh
//   //////////////////////////////////////////////////////////////
//   function refreshCustomCartPage() {
//     if (refreshLock) {
//       queuedRefresh = true;
//       return;
//     }

//     refreshLock = true;

//     fetch('/?sections=header,main-cart-footer', {
//       credentials: 'same-origin',
//       cache: 'no-store'
//     })
//       .then(r => r.json())
//       .then(data => {
//         const parser = new DOMParser();

//         const cartDoc = parser.parseFromString(
//           data['main-cart-footer'] || '',
//           'text/html'
//         );

//         const headerDoc = parser.parseFromString(
//           data.header || '',
//           'text/html'
//         );

//         const newCart = cartDoc.querySelector('.custom-cart-page');
//         const currentCart = document.querySelector('.custom-cart-page');

//         if (newCart && currentCart) {
//           currentCart.innerHTML = newCart.innerHTML;
//         }

//         const newBubbles = headerDoc.querySelectorAll('#cart-icon-bubble');
//         const currentBubbles = document.querySelectorAll('#cart-icon-bubble');

//         currentBubbles.forEach((bubble, i) => {
//           const source = newBubbles[i] || newBubbles[0];
//           if (!source) return;
//           bubble.innerHTML = source.innerHTML;
//           bubble.className = source.className;
//         });

//         requestAnimationFrame(debouncedRun);
//       })
//       .finally(() => {
//         refreshLock = false;

//         if (queuedRefresh) {
//           queuedRefresh = false;
//           requestAnimationFrame(refreshCustomCartPage);
//         }
//       });
//   }

//   //////////////////////////////////////////////////////////////
//   // Fetch Hook
//   //////////////////////////////////////////////////////////////
//   const originalFetch = window.fetch;

//   window.fetch = function () {
//     const url = arguments[0];

//     return originalFetch.apply(this, arguments).then(response => {
//       const requestURL =
//         typeof url === 'string' ? url : url?.url || '';

//       if (/\/cart\/(add|change|update|clear)/.test(requestURL)) {
//         requestAnimationFrame(refreshCustomCartPage);
//       }

//       return response;
//     });
//   };

//   //////////////////////////////////////////////////////////////
//   // XHR Hook
//   //////////////////////////////////////////////////////////////
//   const oldOpen = XMLHttpRequest.prototype.open;
//   const oldSend = XMLHttpRequest.prototype.send;

//   XMLHttpRequest.prototype.open = function (method, url) {
//     this._url = url;
//     return oldOpen.apply(this, arguments);
//   };

//   XMLHttpRequest.prototype.send = function () {
//     this.addEventListener('load', () => {
//       if (/\/cart\/(add|change|update|clear)/.test(this._url || '')) {
//         requestAnimationFrame(refreshCustomCartPage);
//       }
//     });

//     return oldSend.apply(this, arguments);
//   };

//   //////////////////////////////////////////////////////////////
//   // Observer
//   //////////////////////////////////////////////////////////////
//   requestAnimationFrame(() => {
//     const cart = document.querySelector('.custom-cart-page');

//     if (!cart) return;

//     const observer = new MutationObserver(debouncedRun);

//     observer.observe(cart, {
//       childList: true,
//       subtree: true
//     });
//   });

//   //////////////////////////////////////////////////////////////
//   // Events
//   //////////////////////////////////////////////////////////////
//   document.addEventListener('DOMContentLoaded', debouncedRun);
//   document.addEventListener('shopify:section:load', debouncedRun);

//   //////////////////////////////////////////////////////////////
//   // API
//   //////////////////////////////////////////////////////////////
//   window.DotKeyIpSale = {
//     getComparePriceByVariantId,
//     applyTieredPricing,
//     getEligibleItems,
//     hasAbove348Eligible,
//     isIpSaleExcluded,
//     LIP_TYPES,
//     EXCLUDED_TYPES,
//     EXCLUDED_VARIANT_IDS,
//     EXCLUDED_PRODUCT_IDS
//   };
// })();


(function () {
  if (window.__DOTKEY_CART_FINAL__) return;
  window.__DOTKEY_CART_FINAL__ = true;

  //////////////////////////////////////////////////////////////
  // RAF Debounce
  //////////////////////////////////////////////////////////////
  function debounce(fn) {
    let raf;
    return function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(fn);
    };
  }

  //////////////////////////////////////////////////////////////
  // Variant Cache
  //////////////////////////////////////////////////////////////
  const variantCache = Object.create(null);
  let cartLock = false;
  let refreshLock = false;
  let queuedRefresh = false;
  let lastCartSignature = '';
  let lastDomSignature = '';
  let observerPaused = false;

  async function getComparePriceByVariantId(id) {
    if (variantCache[id]) return variantCache[id];

    try {
      const r = await fetch('/variants/' + id + '.js', {
        credentials: 'same-origin',
        cache: 'force-cache'
      });

      if (!r.ok) return null;

      const v = await r.json();

      return (variantCache[id] = {
        compare_price: v.compare_at_price ? v.compare_at_price / 100 : 0,
        price: v.price / 100
      });
    } catch {
      return null;
    }
  }

  //////////////////////////////////////////////////////////////
  // Constants
  //////////////////////////////////////////////////////////////
  const LIP_TYPES = ['lip balm', 'lip care', 'lip'];
  const EXCLUDED_TYPES = ['combo', 'flashsale', 'flashstore', 'merch', 'free'];
  const EXCLUDED_VARIANT_IDS = [46582474244326, 47284867793126];
  const EXCLUDED_PRODUCT_IDS = [];

  //////////////////////////////////////////////////////////////
  // Helpers
  //////////////////////////////////////////////////////////////
  function isIpSaleExcluded(item) {
    return (
      EXCLUDED_VARIANT_IDS.includes(item.variant_id) ||
      EXCLUDED_PRODUCT_IDS.includes(item.product_id)
    );
  }

  function hasAbove348Eligible(items) {
    for (const i of items) {
      const t = (i.product_type || '').toLowerCase();

      if (
        isIpSaleExcluded(i) ||
        EXCLUDED_TYPES.includes(t) ||
        LIP_TYPES.includes(t)
      ) continue;

      const price = variantCache[i.variant_id]?.price || 0;

      if (price > 348) return true;
    }

    return false;
  }

  function getEligibleItems(items) {
    const allowCheap = hasAbove348Eligible(items);
    let total = 0;
    const eligible = [];

    for (const i of items) {
      const t = (i.product_type || '').toLowerCase();

      if (
        isIpSaleExcluded(i) ||
        EXCLUDED_TYPES.includes(t) ||
        LIP_TYPES.includes(t)
      ) continue;

      const price = variantCache[i.variant_id]?.price || 0;

      if (price <= 348 && !allowCheap) continue;

      total += price * i.quantity;
      eligible.push(i);
    }

    return total < 699 ? [] : eligible;
  }

  //////////////////////////////////////////////////////////////
  // Pricing Logic (unchanged)
  //////////////////////////////////////////////////////////////
  function applyTieredPricing(cartItems) {
    const lipUnits = [];
    const nonDiscountMap = {};
    const lipDiscountMap = {};

    for (const i of cartItems) {
      const t = (i.product_type || '').toLowerCase();

      const unit =
        variantCache[i.variant_id]?.price ||
        i.original_line_price / i.quantity / 100;

      if (LIP_TYPES.includes(t) && !isIpSaleExcluded(i)) {
        for (let q = 0; q < i.quantity; q++) {
          lipUnits.push({ key: i.key, price: unit });
        }
        continue;
      }

      if (EXCLUDED_TYPES.includes(t) || isIpSaleExcluded(i)) {
        if (!nonDiscountMap[i.key]) {
          nonDiscountMap[i.key] = { key: i.key, qty: 0, price: unit };
        }
        nonDiscountMap[i.key].qty += i.quantity;
      }
    }

    lipUnits.sort((a, b) => b.price - a.price);

    const lipPairs = Math.floor(lipUnits.length / 2);
    const lipDiscountTotal = lipPairs * 35000;

    if (lipPairs) {
      const used = lipUnits.slice(0, lipPairs * 2);
      let original = 0;

      used.forEach(u => {
        original += u.price;

        if (!lipDiscountMap[u.key]) {
          lipDiscountMap[u.key] = { qty: 0, price: u.price };
        }

        lipDiscountMap[u.key].qty++;
      });

      Object.values(lipDiscountMap).forEach(v => {
        v.discounted_total = Math.round(
          lipDiscountTotal * ((v.qty * v.price) / original)
        );
      });
    }

    const tierUnits = [];
    const eligibleItems = getEligibleItems(cartItems);

    for (const i of eligibleItems) {
      const unit =
        variantCache[i.variant_id]?.compare_price ||
        i.original_line_price / i.quantity / 100;

      for (let q = 0; q < i.quantity; q++) {
        tierUnits.push({ key: i.key, price: unit });
      }
    }

    const tierPricing = {
      2: 69900,
      3: 99900,
      4: 129500,
      5: 169800,
      6: 199800,
      8: 259000
    };

    let discountedUnits = [];
    let fullUnits = [];
    let discountedTotal = 0;

    if (tierUnits.length >= 8) {
      discountedUnits = tierUnits.slice(0, 8);
      fullUnits = tierUnits.slice(8);
      discountedTotal = tierPricing[8];
    } else if (tierUnits.length === 7) {
      discountedUnits = tierUnits.slice(0, 6);
      fullUnits = tierUnits.slice(6);
      discountedTotal = tierPricing[6];
    } else if (tierPricing[tierUnits.length]) {
      discountedUnits = tierUnits;
      discountedTotal = tierPricing[tierUnits.length];
    } else {
      fullUnits = tierUnits;
    }

    const discountedItems = [];
    const discountMap = {};

    if (discountedUnits.length) {
      let original = 0;

      discountedUnits.forEach(u => {
        original += u.price;

        if (!discountMap[u.key]) {
          discountMap[u.key] = { qty: 0, price: u.price };
        }

        discountMap[u.key].qty++;
      });

      Object.entries(discountMap).forEach(([k, v]) => {
        discountedItems.push({
          key: k,
          discounted_total: Math.round(
            discountedTotal * ((v.qty * v.price) / original)
          )
        });
      });
    }

    fullUnits.forEach(u => {
      if (!nonDiscountMap[u.key]) {
        nonDiscountMap[u.key] = { key: u.key, qty: 0, price: u.price };
      }
      nonDiscountMap[u.key].qty++;
    });

    Object.entries(lipDiscountMap).forEach(([k, v]) => {
      discountedItems.push({
        key: k,
        discounted_total: v.discounted_total
      });
    });

    lipUnits.slice(lipPairs * 2).forEach(u => {
      if (!nonDiscountMap[u.key]) {
        nonDiscountMap[u.key] = { key: u.key, qty: 0, price: u.price };
      }
      nonDiscountMap[u.key].qty++;
    });

    return {
      discountedItems,
      nonDiscountedItems: Object.values(nonDiscountMap)
    };
  }

  //////////////////////////////////////////////////////////////
  // UI
  //////////////////////////////////////////////////////////////
  function updateCartPricesDisplay(data) {
    observerPaused = true;

    const map = {};

    data.discountedItems.forEach(i => {
      map[i.key] = (map[i.key] || 0) + i.discounted_total;
    });

    data.nonDiscountedItems.forEach(i => {
      map[i.key] = (map[i.key] || 0) + i.price * i.qty * 100;
    });

    document.querySelectorAll('.custom-cart-page .cart-item__discounted-prices')
      .forEach(c => {
        const key = c.dataset.key;
        const qty = +c.dataset.quantity || 1;
        const variantId = +c.dataset.variantId;
        const v = variantCache[variantId];

        if (!v) return;

        const old = c.querySelector('.cart-item__old-price');
        const fin = c.querySelector('.cart-item__final-price');

        if (!fin) return;

        const original =
          old?.dataset.originalPrice
            ? parseFloat(old.dataset.originalPrice)
            : parseFloat(fin.textContent.replace(/[^\d.]/g, '')) || 0;

        const final = map[key] !== undefined ? map[key] / 100 : original;

        if (old) {
          if (final < original) {
            old.textContent = `₹${original.toFixed(2)}`;
            old.style.display = 'inline-block';
            old.style.textDecoration = 'line-through';
          } else {
            old.style.display = 'none';
          }
        }

        fin.textContent =
          final < original
            ? `₹${final.toFixed(2)}`
            : `₹${(v.price * qty).toFixed(2)}`;
      });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        observerPaused = false;
      });
    });
  }

  function getTotalDiscount() {
    let o = 0;
    let f = 0;

    document.querySelectorAll('.custom-cart-page .cart-item__discounted-prices')
      .forEach(i => {
        const oldEl = i.querySelector('.cart-item__old-price');
        const finalEl = i.querySelector('.cart-item__final-price');

        if (!finalEl) return;

        const oldPrice = parseFloat(
          (oldEl || finalEl).textContent.replace(/[^\d.]/g, '')
        );

        const finalPrice = parseFloat(
          finalEl.textContent.replace(/[^\d.]/g, '')
        );

        if (!isNaN(oldPrice) && !isNaN(finalPrice)) {
          o += oldPrice;
          f += finalPrice;
        }
      });

    return o > f ? (o - f).toFixed(2) : '0.00';
  }

  //////////////////////////////////////////////////////////////
  // Main
  //////////////////////////////////////////////////////////////
  async function runCartDiscountUI(force) {
    if (cartLock) return;
    cartLock = true;

    try {
      const r = await originalFetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!r.ok) return;

      const cart = await r.json();

      const signature = cart.items
        .map(i => `${i.key}:${i.quantity}`)
        .join('|');

      if (!force && signature === lastCartSignature) return;
      lastCartSignature = signature;

      if (!cart.items.length) return;

      await Promise.all(
        cart.items.map(i => getComparePriceByVariantId(i.variant_id))
      );

      const data = applyTieredPricing(cart.items);

      updateCartPricesDisplay(data);

      const save = getTotalDiscount();

      const tag = document.querySelector('.custom-cart-page #savings_cart_page');

      if (tag) {
        tag.style.display = save > 0 ? 'block' : 'none';
        tag.textContent = save > 0 ? '- ₹' + save : '';
      }

      const cartEl = document.querySelector('.custom-cart-page');
      if (cartEl) {
        lastDomSignature = cartEl.innerText;
      }

    } finally {
      cartLock = false;
    }
  }

  const debouncedRun = debounce(function () {
    runCartDiscountUI(false);
  });

  //////////////////////////////////////////////////////////////
  // Refresh
  //////////////////////////////////////////////////////////////
  function refreshCustomCartPage() {
    if (refreshLock) {
      queuedRefresh = true;
      return;
    }

    refreshLock = true;

    originalFetch('/?sections=header,main-cart-footer', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(r => r.json())
      .then(data => {
        const parser = new DOMParser();

        const cartDoc = parser.parseFromString(
          data['main-cart-footer'] || '',
          'text/html'
        );

        const headerDoc = parser.parseFromString(
          data.header || '',
          'text/html'
        );

        const newCart = cartDoc.querySelector('.custom-cart-page');
        const currentCart = document.querySelector('.custom-cart-page');

        if (newCart && currentCart) {
          observerPaused = true;
          currentCart.innerHTML = newCart.innerHTML;

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              observerPaused = false;
              runCartDiscountUI(true);
            });
          });
        }

        const newBubbles = headerDoc.querySelectorAll('#cart-icon-bubble');
        const currentBubbles = document.querySelectorAll('#cart-icon-bubble');

        currentBubbles.forEach((bubble, i) => {
          const source = newBubbles[i] || newBubbles[0];
          if (!source) return;
          bubble.innerHTML = source.innerHTML;
          bubble.className = source.className;
        });
      })
      .finally(() => {
        refreshLock = false;

        if (queuedRefresh) {
          queuedRefresh = false;
          requestAnimationFrame(refreshCustomCartPage);
        }
      });
  }

  //////////////////////////////////////////////////////////////
  // Fetch Hook
  //////////////////////////////////////////////////////////////
  const originalFetch = window.fetch;

  window.fetch = function () {
    const url = arguments[0];

    return originalFetch.apply(this, arguments).then(response => {
      const requestURL =
        typeof url === 'string' ? url : url?.url || '';

      if (
        /\/cart\/(add|change|update|clear)/.test(requestURL) &&
        requestURL.indexOf('/cart.js') === -1
      ) {
        requestAnimationFrame(refreshCustomCartPage);
      }

      return response;
    });
  };

  //////////////////////////////////////////////////////////////
  // Observer
  //////////////////////////////////////////////////////////////
  requestAnimationFrame(() => {
    const cart = document.querySelector('.custom-cart-page');
    if (!cart) return;

    const observer = new MutationObserver(() => {
      if (observerPaused) return;

      const current = cart.innerText;
      if (current === lastDomSignature) return;

      lastDomSignature = current;
      debouncedRun();
    });

    observer.observe(cart, {
      childList: true,
      subtree: true
    });
  });

  //////////////////////////////////////////////////////////////
  // Events
  //////////////////////////////////////////////////////////////
  document.addEventListener('DOMContentLoaded', function () {
    runCartDiscountUI(true);
  });

  document.addEventListener('shopify:section:load', function () {
    runCartDiscountUI(true);
  });

  //////////////////////////////////////////////////////////////
  // API
  //////////////////////////////////////////////////////////////
  window.DotKeyIpSale = {
    getComparePriceByVariantId,
    applyTieredPricing,
    getEligibleItems,
    hasAbove348Eligible,
    isIpSaleExcluded,
    LIP_TYPES,
    EXCLUDED_TYPES,
    EXCLUDED_VARIANT_IDS,
    EXCLUDED_PRODUCT_IDS
  };
})();